<template>
  <span class="text"
    >Детальніше<img
      class="infoIcon"
      src="@/assets/icons/infoIcon.svg"
      alt="infoIcon"
  /></span>
</template>

<script>
export default {
  name: 'InfoButton'
};
</script>

<style lang="scss" scoped>
.infoIcon {
  width: 0.868rem;
  margin-left: 0.503rem;
}

.text {
  display: flex;
  font-size: 0.764rem;
  line-height: 120%;
}
@media screen and (max-width: 768px) {
  .infoIcon {
    width: 3.9625rem;
    margin-left: 2.265rem;
  }

  .text {
    font-size: 3.4375rem;
  }
}
</style>
